export default __webpack_public_path__ + "static/media/nasa.55d3a353.webp";